import {connect} from "react-redux";
import StartPage from "../components/StartPage";
                                                  
                                    
import {setCategory, SPECIAL_CATEGORY} from "../actions/filter";

function mapStateToProps(state                  ) {
	return {
		products: state.content.topProducts,
		categories: state.filter.filterStats.categories,
		manufacturerTitle: state.config.manufacturerTitle,
	};
}

function mapDispatchToProps(dispatch          , state                  ) {
	return {
		allProducts: () => {
			dispatch(setCategory(SPECIAL_CATEGORY.TOP));
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(StartPage);
